import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Layout from '../../layouts/page';
import Spinner from '../../components/spinner';
import Backbtn from '../../components/backbtn';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { config } from '../../config';
import FormField from '../../components/formfield';
import Submit from '../../components/button';

const UpdateMember = () => {
  const { id } = useParams(); // Get member ID from URL params
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone_number: '',
    password: '',
    password_confirmation: '',
    email_verified_at: '', 
    status: '',  // Ensure this field exists
  });

  const [loading, setLoading] = useState(false);
  const storedToken = localStorage.getItem('auth_token');

  // Fetch member data when component mounts
  useEffect(() => {
    const fetchMember = async () => {
      if (!storedToken) {
        toast.error('Authentication token is missing. Please log in again.');
        setLoading(false);
        return;
      }
      
      try {
        setLoading(true);
        const response = await axios.get(`${config.api_path}/estate-members/${id}`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        });

        const data = response.data.data;

        if (data) {
          setFormData({
            name: data.name,
            email: data.email,
            phone_number: data.phone_number,
            password: '',
            password_confirmation: '',
            email_verified_at: data.email_verified_at,
            status: data.status,  // Fetch approval status
          });
        } else {
          toast.error("Error fetching member details");
        }
      } catch (error) {
        toast.error("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchMember();
  }, [id]);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Submit form data to backend
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.put(`${config.api_path}/estate-members/${id}`, formData, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${storedToken}`
        }
      });

      const result = response.data;

      if (result) {
        toast.success("Member updated successfully");
        setTimeout(() => navigate('/estate-members'), 2000);
      } else {
        toast.error("Failed to update member");
      }
    } catch (error) {
      toast.error("An error occurred");
      console.error("Error updating member:", error.response?.data || error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
  <div className="col-12 grid-margin">
    <div className="card">
      <div className="card-body">
        <h4>Edit Estate Member</h4>
        <Backbtn />
        {loading && <Spinner />}
        {!loading && (
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <FormField label="Full-Name" name="name" value={formData.name} onChange={handleInputChange} required />
              <FormField label="Email" name="email" type="email" value={formData.email} onChange={handleInputChange} required />
              <FormField label="Telephone Number" name="phone_number" type="tel" value={formData.phone_number} onChange={handleInputChange} required />
            </div>

            <div className="form-row">
              <div className="form-group col-md-6">
                <label>Verification Status</label>
                <select
                  name="email_verified_at"
                  value={formData.email_verified_at ? "true" : "false"} 
                  onChange={(e) => handleInputChange({
                    target: { name: "email_verified_at", value: e.target.value === "true" }
                  })}
                  className="form-control">
                  <option value="true">Verified</option>
                  <option value="false">Not Verified</option>
                </select>
              </div>

              <div className="form-group col-md-6">
                <label>Approval Status</label>
                <select
                  name="status"
                  value={formData.status || "Pending"}
                  onChange={handleInputChange}
                  className="form-control">
                  <option value="Approved">Approved</option>
                  <option value="Pending">Pending</option>
                  <option value="Denied">Denied</option>
                </select>
              </div>
            </div>

            <div className="form-row ">
              <FormField label="Password" name="password" type="password" value={formData.password} onChange={handleInputChange} />
              <FormField label="Confirm Password" name="password_confirmation" type="password" value={formData.password_confirmation} onChange={handleInputChange} />
            </div>

            <Submit loading={loading} />
          </form>
        )}
        <ToastContainer />
      </div>
    </div>
  </div>
</Layout>

  );
};

export default UpdateMember;
